<template>
  <section class="py-10 mt-6 bg-gray-50">
    <div class="container mx-auto px-4">
      <div class="text-center mb-10">
        <h2 class="text-4xl font-bold mb-4 gig-landing-text-purple">
          Sıkça Sorulan Sorular
        </h2>
        <p class="text-lg text-gray-600 max-w-2xl mx-auto">
          Gigcep hakkında merak ettiğiniz her şey
        </p>
      </div>

      <div class="max-w-3xl mx-auto">
        <div
          v-for="(faq, index) in faqs"
          class="mb-4"
          data-aos="fade-up"
          :data-aos-delay="index * 100"
        >
          <button
            :class="`w-full text-left p-6 rounded-xl bg-white shadow-md hover:shadow-lg transition-all duration-300`"
            :style="{
              border:
                openIndex === index
                  ? '1px solid #6366f1'
                  : '1px solid transparent',
            }"
            @click="openIndex = openIndex === index ? null : index"
          >
            <div class="flex justify-between items-center">
              <h3 class="text-lg font-semibold text-gray-900">
                {{ faq.question }}
              </h3>
              <template v-if="openIndex === index">
                <span class="text-indigo-600">
                  <Icon
                    name="mingcute:down-line"
                    class="inline-block w-5 h-5"
                  />
                </span>
              </template>
              <template v-else>
                <span class="text-gray-400">
                  <Icon name="mingcute:up-line" class="inline-block w-5 h-5" />
                </span>
              </template>
            </div>
            <div
              :class="`mt-2 text-gray-600 transition-all duration-300 overflow-hidden ${
                openIndex === index
                  ? 'max-h-48 opacity-100'
                  : 'max-h-0 opacity-0'
              }`"
            >
              {{ faq.answer }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
const openIndex = ref<number | null>(null)
const faqs = ref([
  {
    question: "Gigcep nedir?",
    answer:
      "Gigcep, kullanıcıların basit gigleri tamamlayarak gerçek ödüller kazanabildiği bir mobil uygulamadır. Boş zamanlarınızı değerlendirirken hediyeler kazanmanızı sağlar.",
  },
  {
    question: "Nasıl ödül kazanabilirim?",
    answer:
      "Uygulama içerisinde size sunulan gigleri tamamlayarak puan kazanabilirsiniz. Bu puanları hediye çekleri, dijital ödüller ve daha fazlası için kullanabilirsiniz.",
  },
  {
    question: "Kazandığım ödülleri nasıl alabilirim?",
    answer:
      "Yeterli puanı topladığınızda, ödül kataloğundan dilediğiniz hediyeyi seçebilirsiniz. Dijital hediyeler anında hesabınıza tanımlanır, fiziksel hediyeler ise adresinize gönderilir.",
  },
  {
    question: "Minimum ödül limiti nedir?",
    answer:
      "Minimum ödül limiti hediye tipine göre değişiklik göstermektedir. Hediye çekleri için genellikle 50 TL'den başlayan seçenekler mevcuttur.",
  },
  {
    question: "Gigcep güvenilir mi?",
    answer:
      "Evet, Gigcep yasal olarak kayıtlı bir şirkettir ve tüm ödüller garantilidir. Kullanıcı bilgileriniz KVKK kapsamında güvenle saklanır.",
  },
])
</script>
